import React from 'react'
import { achievementsStatsConfig } from '../../../pages/shipping/show/config'
import StatsCard from '../../UI/staticsCard'

const AchievementsCard = ({achievements}) => {
    const  achievementsData=achievementsStatsConfig(achievements)
  return (
    <div className='card rounded-3 shadow-sm'>
        <div className="card-body">
          <h5 className='fw-bold mb-4'>الإنجازات</h5>
        {  achievementsData.map((achievement ,i)=>(
            <StatsCard key={i} {...achievement} />
          ))}
        </div>
    </div>
  )
}

export default AchievementsCard